import { IconFileText, IconTicket } from "@tabler/icons-react";

// Campaign templates that pre-fill a new campaign. Each template declares the
// static fields it sets (subject, attachments) plus an optional `bodyTemplate`
// naming a server-side email template. The body itself is the .html file in
// apps/api/src/mailer/templates — the single source of truth — fetched at
// selection time and parsed into the editor by TipTap's setContent. We don't
// duplicate the content as Tiptap JSON here.
//
// To add a template: add an entry below. If its body should come from a server
// template, set `bodyTemplate` to the template file name; otherwise it starts blank.
export const CAMPAIGN_TEMPLATES = [
  {
    id: "blank",
    name: "Blank",
    description: "Start from an empty campaign.",
    icon: IconFileText,
    // Mantine theme color for the template's icon.
    color: "gray",
  },
  {
    id: "ticketDownload",
    name: "Ticket download",
    description: "Pre-filled email with an app download button.",
    icon: IconTicket,
    color: "blue",
    subject: "Your ticket for {{eventName}}",
    bodyTemplate: "ticketDownload",
    attachments: [],
  },
];
